import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LayoutPreset } from "@/components/AppHeader/hooks/useLayoutPresets";
import { TypographyPreset } from "@/components/AppHeader/hooks/useTypographyPresets";

export enum ModalType {
  AI = "AI",
  None = "None",
  Frame = "Frame",
  Text = "Text",
  Image = "Image",
  CreateComponent = "CreateComponent",
}

export enum CursorType {
  Pointer = "pointer",
  Text = "text",
  Draw = "draw",
  Drive = "drive",
  Pan = "pan",
}

export const globalSettingsSlice = createSlice({
  name: "globalSettings",
  initialState: {
    // Canvas controls
    cursorType: CursorType.Pointer,
    selectedTypographyOption: null,
    previousCursorType: CursorType.Pointer,

    // If the cursor type was changed from a key down event
    cursorTypeFromKeyDown: false,

    // Cursor and keyboard modifier states
    isSpacePressed: false,
    isMiddleMousePressed: false,
    isMetaPressed: false,
    isCtrlPressed: false,

    // Element interaction states
    triggerDeleteElement: false,

    showModal: ModalType.None,
    selectedLayoutOption: null,
  },
  reducers: {
    setCursorType: (state, action) => {
      const { cursorType, fromKeyDown } = action.payload;

      if (cursorType !== state.cursorType) {
        state.previousCursorType = state.cursorType;
      }

      state.cursorType = cursorType;
      state.cursorTypeFromKeyDown = fromKeyDown;
    },
    setModal: (state, action: PayloadAction<ModalType>) => {
      state.showModal = action.payload;
    },
    revertCursorType: (state) => {
      const currentType = state.cursorType;
      state.cursorType = state.previousCursorType;
      state.previousCursorType = currentType;
      state.cursorTypeFromKeyDown = false;
    },
    setSelectedTypographyOption: (
      state,
      action: PayloadAction<TypographyPreset>,
    ) => {
      // @ts-expect-error TS2322
      state.selectedTypographyOption = action.payload;
    },
    setSelectedLayoutOption: (state, action: PayloadAction<LayoutPreset>) => {
      // @ts-expect-error TS2322
      state.selectedLayoutOption = action.payload;
    },
    setIsSpacePressed: (state, action: PayloadAction<boolean>) => {
      state.isSpacePressed = action.payload;
    },
    setIsMiddleMousePressed: (state, action: PayloadAction<boolean>) => {
      state.isMiddleMousePressed = action.payload;
    },
    setIsMetaPressed: (state, action: PayloadAction<boolean>) => {
      state.isMetaPressed = action.payload;
    },
    setIsCtrlPressed: (state, action: PayloadAction<boolean>) => {
      state.isCtrlPressed = action.payload;
    },
    setTriggerDeleteElement: (state, action: PayloadAction<boolean>) => {
      state.triggerDeleteElement = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCursorType,
  setSelectedTypographyOption,
  revertCursorType,
  setModal,
  setSelectedLayoutOption,
  setIsSpacePressed,
  setIsMiddleMousePressed,
  setIsMetaPressed,
  setIsCtrlPressed,
  setTriggerDeleteElement,
} = globalSettingsSlice.actions;

export default globalSettingsSlice.reducer;
